import { Component, OnInit } from '@angular/core';
import { AuthService } from '../users/auth.service'
import { Router } from '@angular/router'
import { ModalDirective } from 'ng2-bootstrap/modal/modal.component';
import { FormControl, FormGroup  }   from '@angular/forms';
import { Validators, FormArray, FormBuilder } from '@angular/forms';
import {matchOtherValidator} from './match-other-validator'
@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {

  constructor( private authService: AuthService , private router: Router) { }

  public isLoggedIn:boolean = false; 
  public u:any
    User = {
    UserId: 0,
    UserName: "",
    FirstName: "",
    LastName: "",
    Role: 0
  }
  private UserId:FormControl
  private CurrentPassword:FormControl
  private NewPassword:FormControl
  private NewPasswordConfirm:FormControl

  resetPassForm : FormGroup

  public disabled:boolean = false;
  public status:{isopen:boolean} = {isopen: false};

  public toggled(open:boolean):void {
    console.log('Dropdown is now: ', open);
  }

  public toggleDropdown($event:MouseEvent):void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }
  logout(){
    this.authService.logout()
  }

  ngOnInit(): void {
    this.isLoggedIn =  this.authService.isAuthenticated()
    if(!this.isLoggedIn){
      this.router.navigate(['pages/login']);
      this.InitializeWLform()
    }
    else{
    this.u = this.authService.getCurrentUser()
    this.User.Role = this.u.Role
    this.User.UserId=this.u.UserId
    this.User.UserName=this.u.UserName
    this.User.FirstName=this.u.FirstName
    this.User.LastName=this.u.LastName
    console.log(this.User)
    this.InitResetForm()
     }

  }

  InitResetForm(){
    this.UserId =  new FormControl(this.u.UserId,Validators.compose([Validators.required, Validators.pattern(".*\\S.*")]))
    this.CurrentPassword =  new FormControl('',Validators.compose([Validators.required, Validators.pattern(".*\\S.*")]))
    this.NewPassword =  new FormControl('',Validators.compose([Validators.required, Validators.pattern(".*\\S.*")]))
    this.NewPasswordConfirm =  new FormControl('',Validators.compose([Validators.required, matchOtherValidator("NewPassword"), Validators.pattern(".*\\S.*") ]))
    
    this.resetPassForm = new FormGroup({
      UserId : this.UserId,
      CurrentPassword : this.CurrentPassword,
      NewPassword : this.NewPassword,
      NewPasswordConfirm : this.NewPasswordConfirm
      
    },)
  }

  InitializeWLform(){
    this.UserId =  new FormControl('',Validators.compose([Validators.required, Validators.pattern(".*\\S.*")]))
    this.CurrentPassword =  new FormControl('',Validators.compose([Validators.required, Validators.pattern(".*\\S.*")]))
    this.NewPassword =  new FormControl('',Validators.compose([Validators.required, Validators.pattern(".*\\S.*")]))
    this.NewPasswordConfirm =  new FormControl('',Validators.compose([Validators.required, matchOtherValidator("NewPassword"), Validators.pattern(".*\\S.*") ]))
    
    this.resetPassForm = new FormGroup({
      UserId : this.UserId,
      CurrentPassword : this.CurrentPassword,
      NewPassword : this.NewPassword,
      NewPasswordConfirm : this.NewPasswordConfirm
      
    },)
  }
disableSubmitButtonOfResetPass: boolean
showResetSuccess: boolean
showResetError : boolean
resetModalLoading : boolean
errorDisc : any = ''
  ChangePass(dataFromForm){
    this.resetModalLoading = true
    this.u = this.authService.getCurrentUser();
    dataFromForm.UserId = this.u.UserId
      console.log(dataFromForm)
      this.disableSubmitButtonOfResetPass = true
      this.authService.ChangePassword(dataFromForm).subscribe(
        response => {
          console.log(response)
          
          if(response.Status == 1){
          //this.toasterService.pop('success', 'Success', 'Edited successfully!')
          this.disableSubmitButtonOfResetPass = false
          this.resetModalLoading = false
          this.showResetSuccess = true
          this.router.navigate(['pages/login'])
          setTimeout(() => { 
            this.showResetSuccess = false
          }, 1500)
        }
        else{
          this.disableSubmitButtonOfResetPass = false
          this.resetModalLoading = false
          this.showResetError = true
          this.errorDisc = response.error
          setTimeout(() => { 
            this.showResetError = false
          }, 5000)
        }
    }, // success
        error => console.log(error),       // error
        () => {
          console.log('completed')
          this.disableSubmitButtonOfResetPass = false
      })     // complete
  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      let passwordInput = group.controls[passwordKey],
          passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({notEquivalent: true})
      }
      else {
          return passwordConfirmationInput.setErrors(null);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts